import Alert from 'antd/lib/alert';
import React, { ReactElement } from 'react';

import classes from './VerifyLegacyPlatformIDCaution.module.css';

const helpUrl = 'https://import-io.atlassian.net/wiki/spaces/ES/pages/1752694915/Legacy+Platform+ID+Verification';

const VerifyLegacyPlatformIDCaution = (): ReactElement => {
  return (
    <Alert
      className={classes.cautionBody}
      type="warning"
      showIcon
      message="Verify Legacy Platform ID"
      description={
        <>
          Please check Legacy Platform ID for existence using Hades application. See{' '}
          <a href={helpUrl} target="_blank" className="wb-textDecoration-underline">
            this page
          </a>{' '}
          for details.
        </>
      }
    />
  );
};

export default VerifyLegacyPlatformIDCaution;
